angular.module('invoice')
    .controller('InvoiceAssignmentRuleFromInvoiceController', function ($scope, $uibModalInstance, data, InvoiceAssignmentRule, toastr) {
        this.invoiceId = data?.invoiceId || data?.id
        this.seller = data?.seller || data?.invoice?.seller || null
        this.buyer = data?.buyer || data?.invoice?.buyer || null
        this.worker = data?.worker || data?.invoice?.worker || null
        this.scope = data?.scope || 'LOCAL'
        this.canCreateGlobalRule = !!data?.canCreateGlobalRule
        this.ruleModes = ['FIXED', 'ROUND_ROBIN', 'LEAST_LOADED']

        this.$onInit = () => {
            this.form = {
                sellerNip: this.seller?.taxNo,
                sourceType: 'KSEF',
                assignMode: 'ROUND_ROBIN',
                scope: this.scope,
                active: true,
                confidential: false,
                addRuleUsersToWorkflow: false,
                users: [],
                accessGroups: []
            }
            this.onScopeChanged()
        }

        this.save = () => {
            return InvoiceAssignmentRule.createFromInvoice({invoiceId: this.invoiceId}, this.form).$promise.then(() => {
                toastr.success('Zapisano regułę')
                $uibModalInstance.close('saved')
            })
        }

        this.isUsersRequiredInvalid = () => !this.form?.users || this.form.users.length === 0
        this.isConfidentialGroupsInvalid = () => !!this.form?.confidential && (!this.form.accessGroups || this.form.accessGroups.length === 0)
        this.onConfidentialChanged = () => {
            if (!this.form?.confidential) {
                this.form.accessGroups = []
            }
        }
        this.onScopeChanged = () => {
            if (this.form?.scope === 'GLOBAL' && !this.canCreateGlobalRule) {
                this.form.scope = 'LOCAL'
            }
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
    })
